export default __webpack_public_path__ + "static/media/1P.8337cb70.png";